export default "__VITE_PUBLIC_ASSET__2fd1b15a__"